export default {
  "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["hello i18n !!"])},
  "espaceClientWelcome": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Go to your customer area"])},
  "espaceClientLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Login"])}
}